import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {RequestService} from "../../../../services/request/request.service";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {WarningModalContentComponent} from "../../../../lib/warning-modal/warning-modal.component";

@Component({
  selector: 'app-single-background-check-recipient',
  templateUrl: './single-background-check-recipient.component.pug',
  styleUrls: ['./single-background-check-recipient.component.scss'],
  standalone: false
})
export class SingleBackgroundCheckRecipientComponent {

  @Input() recipient: any;
  @Input() backgroundChecks : any;
  @Input() flowsSelected : any;
  @Input() disable_edit = false;
  @Input() componentOnModal = false;
  @Output() editEmitter = new EventEmitter();
  @Output() editStartedEmitter = new EventEmitter();
  @Output() editEndedEmitter = new EventEmitter();
  @Output() deleteEmitter = new EventEmitter();
  private bsModalRef: any;
  dataToEdit = {};
  id = -1;
  loading = false;

  isTrustApiConfigured = true;

  constructor(public modalService: BsModalService,
    public requestService: RequestService,
    private alertList: AlertBannerService) {
  }

  editRecipient(recipient) {
    this.id = recipient['id'];
    this.dataToEdit = {
      "draftUid": localStorage.getItem('draft_background_check_uid'),
      "recipient": recipient
    };
    this.editStartedEmitter.emit();
  }

  editRecipientDetails(recipientToEdit) {
    let checks: any;
    checks = this.backgroundChecks

    this.loading = true;
    this.requestService.editBackgroundChecks(
      recipientToEdit['recipient'],
      localStorage.getItem('draft_background_check_uid'),
      checks
    ).subscribe((data: any) => {
      this.editEmitter.emit(data)
      this.loading = false
    },
      (err: any) => {
        console.log(err);
        this.loading = false
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  deleteRecipient(event) {
    let initialState = {
      "title": $localize`Remove recipient`,
      "message": $localize`Do you want to continue?`
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.loading = true;
        const check: any = undefined;

        this.requestService.removeBackgroundCheck(
          localStorage.getItem('draft_background_check_uid'),
          event['id'],
          check
        ).subscribe((data: any) => {
          this.deleteEmitter.emit(data)
          this.loading = false;
        },
          (err: any) => {
            console.log(err);
            this.loading = false;
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          })
      }
    })
  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error-recipients';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return '';
  }

  avatarInitials(person: { first_name?: string | null; last_name?: string | null } | null): string {
    const first = (person?.first_name || '').charAt(0);
    const last = (person?.last_name || '').charAt(0);
    return `${first}${last}`;
  }

  recipientDisplayName(person: { first_name?: string | null; last_name?: string | null } | null): string {
    return [person?.first_name, person?.last_name].filter(Boolean).join(' ');
  }

  closeEvent() {
    this.id = -1;
    this.editEndedEmitter.emit();
  }

}
